import PropTypes from 'prop-types';

import useProductShowStore from 'stores/product_show_store/useProductShowStore';
import { linkToCollection } from 'lib/addToBasketHelpers';
import { branchTermSingularCapitalised } from 'utils/terminology';
import StockStatus from 'components/product_show/stock_status';

const ChangeStoreLink = ({ children, stepId }) => {
  const { productBasketQuantity, quantitySelectorInput } =
    useProductShowStore();

  return (
    <a
      data-gtm-click="true"
      href={linkToCollection(
        stepId,
        productBasketQuantity || quantitySelectorInput,
      )}
      className="tc-cef-green td-u fw-600">
      {children}
    </a>
  );
};

const CollectionStock = ({
  isDeliveryOnly,
  stepId,
  storeStock,
  selectedStore,
  disabled,
  hasSufficientStock,
}) => {
  const outOfStock =
    !storeStock || storeStock === '0' || isDeliveryOnly || !hasSufficientStock;

  const renderText = () => {
    if (disabled) return 'Collection Disabled';
    if (isDeliveryOnly) return 'Delivery Only';

    if (storeStock > 0) {
      return (
        <>
          {!hasSufficientStock && 'Only '}
          <span
            className={`fw-700 ${
              hasSufficientStock ? 'tc-cef-green' : 'tc-cef-red'
            }`}
            data-testid="product-actions__collection-stock">
            {storeStock}
          </span>
          {' in stock at '}
          <span className="fw-700">
            {selectedStore.replace('Branch', branchTermSingularCapitalised)}
          </span>
        </>
      );
    }
    return (
      <>
        Out of stock at{' '}
        <span className="fw-700" data-testid="product-actions__selected-store">
          {selectedStore.replace('Branch', branchTermSingularCapitalised)}
        </span>
      </>
    );
  };

  return (
    <div className="flex fl-row">
      <StockStatus outOfStock={outOfStock}>
        <span className="mr-4">{renderText()}</span>{' '}
        <ChangeStoreLink
          stepId={stepId}
          data-testid="product-actions__change-store">
          Change
        </ChangeStoreLink>
      </StockStatus>
    </div>
  );
};

CollectionStock.propTypes = {
  isDeliveryOnly: PropTypes.bool,
  stepId: PropTypes.string,
  storeStock: PropTypes.number,
  selectedStore: PropTypes.string,
  disabled: PropTypes.bool,
  hasSufficientStock: PropTypes.bool,
};

export default CollectionStock;
